import { Sms, User } from "iconsax-react";
import InputField from "../../components/inputs/InputField";
import PasswordField from "../../components/inputs/PasswordField";
import { Link, redirect, useNavigate } from "react-router-dom";
import AuthButton from "../../components/buttons/AuthButton";
import { useContext, useEffect, useState } from "react";
import instance from "../../axios/instance";
import { saveToken } from "../../utils/token";

import {
  Box,
  Box1,
  BoxTick,
  Health,
  Hospital,
  Truck,
  Eye,
  EyeSlash,
} from "iconsax-react";
import { Oval } from "react-loader-spinner";

import getCustomSvg from "../../utils/theme/getCustomSvg";
import svgString from "../../svg/svg";
import { ThemeContext } from "../../context/ThemeContext";
import Color from "color";
import { AgreementConsent } from "../../components/AgreementConsent";

export default function LoginPage() {
  const navigate = useNavigate();

  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  // form state
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  // loading state
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  // error message state
  const [errorMessage, setErrorMessage] = useState("");

  const isButtonNotActive = !email || !password;

  function loginDoctor(e) {
    e.preventDefault();
    setErrorMessage("");
    setIsLoading(true);

    const lastFacility = localStorage.getItem("facility");
    const facilityType = localStorage.getItem("facilityType"); //distributor
    instance
      .post("/doctor/auth/login", { email, password, type: "clinic" })
      .then((response) => {
        saveToken(response.data.ACCESS_TOKEN);

        // setTimeout(() => {
        navigate("/dashboard/orders");
        // }, 100);
        // setSuccess(true)
        // setIsLoading(false);
      })
      .catch((error) => {
        setErrorMessage(error.response.data.message);
        setIsLoading(false);
      });
  }

  // logo effect
  const [logo, setLogo] = useState(null);

  useEffect(() => {
    const clinicLogo = window.localStorage.getItem("CLINIC_LOGO");

    console.log("svg is this ", getCustomSvg(svgString, "red"));

    if (clinicLogo === "null" || !clinicLogo) {
      console.log("There is no logo use default");
      setLogo("/clinic/images/logo1.png");
    } else {
      console.log("there is logo");
      setLogo(clinicLogo);
    }
  }, []);

  const { themeColor } = useContext(ThemeContext);

  const customColor = {
    "#3a1b4415": Color(themeColor).alpha(0.2),
    "#3a1b44": themeColor,
  };

  const svgBackground = `data:image/svg+xml;base64,${btoa(
    getCustomSvg(svgString, customColor),
  )}`;

  return (
    <div className="grid grid-cols-5 min-h-[100svh]">
      <div
        style={{
          backgroundImage: `url('${svgBackground}')`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
        className="hidden lg:col-span-3 bg-[#3a1b443c] lg:flex flex-col justify-center relative overflow-clip"
      >
        <div className="px-10 py-4 flex absolute top-0 left-0">
          <img src={logo} className="w-36" />
        </div>

        <div className="rotate-12 text-primary-light absolute -bottom-12 right-6">
          <Health size={120} />
        </div>

        <div className="px-10 py-32 space-y-4">
          <div className="text-black font-bold text-[36px] max-w-[80%]">
            Empower <br />
            individuals on their <br />
            journey to optimal <br />
            health.
          </div>

          <div className="text-black font-regular max-w-[80%]">
            Experience the latest in pharmaceutical advancements with our
            cutting-edge formulations designed to address the unique needs of
            individuals seeking customized anti-aging solutions.
          </div>
        </div>

        <div className="font-medium text-[12px] flex gap-2 items-center absolute right-[10px] bottom-[10px]">
          Powered by
          <img src="/clinic/logo-bw.png" className="w-24" />
        </div>
      </div>

      <div className="py-20 col-span-5 lg:col-span-2 flex justify-center items-center">
        <div className="space-y-4">
          <div className="lg:hidden px-10 py-4 flex absolute top-0 left-0">
            <img src={logo} className="w-36" />
          </div>
          {success ? (
            <div>
              <div className="px-5 font-regular text-gray-600 text-[15px]">
                A link has been sent to your email address. Click on it to sign
                in
              </div>
            </div>
          ) : (
            <>
              <div>
                <div className="font-semibold text-[20px]">Sign in</div>
                <div className="font-regular text-gray-600 text-[15px]">
                  Sign in to an existing account
                </div>
              </div>

              <form onSubmit={loginDoctor} className="space-y-4">
                <div>
                  <div className="font-medium text-[14px] mb-1">
                    Email address
                  </div>
                  <input
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full md:w-[350px] rounded-[4px] bg-[#f1f1f1] border font-regular text-[14px] border-[#D2D2D2] p-2 outline-none"
                    placeholder="Enter email address"
                  />
                </div>

                <div>
                  <div className="font-medium text-[14px] mb-1">Password</div>
                  <div className="w-[350px] rounded-[4px] bg-[#f1f1f1] flex items-center border border-[#D2D2D2] overflow-hidden">
                    <input
                      type={isPasswordVisible ? "text" : "password"}
                      onChange={(e) => setPassword(e.target.value)}
                      className="flex-1 bg-[#f1f1f1] font-regular text-[14px] p-2 outline-none"
                      placeholder="•••••••••"
                    />
                    {isPasswordVisible ? (
                      <EyeSlash
                        color="grey"
                        onClick={() => setIsPasswordVisible(!isPasswordVisible)}
                        className="mr-2 cursor-pointer"
                        size={16}
                      />
                    ) : (
                      <Eye
                        color="grey"
                        onClick={() => setIsPasswordVisible(!isPasswordVisible)}
                        className="mr-2 cursor-pointer"
                        size={16}
                      />
                    )}
                  </div>
                </div>

                <div className="font-semibold text-sm text-red-500 max-w-[350px]">
                  {errorMessage}
                </div>
                <Link
                  to="/auth/forgot-password"
                  className="flex font-medium text-[14px]"
                >
                  Forgot password?
                </Link>

                {/* <div className="font-regular text-[13px] max-w-[350px]">
                  By siging in you agree to BlendcareRx's{" "}
                  <span className="text-primary">Terms of Uses</span>,{" "}
                  <span className="text-primary">Privacy Policy</span>,{" "}
                  <span className="text-primary">
                    HIPAA Policy, Delivery Policy
                  </span>
                  , and{" "}
                  <span className="text-primary">
                    HIPAA marketing authorization
                  </span>
                </div> */}
                <div className="max-w-[350px]">
                  <AgreementConsent signin={true} />
                </div>

                <button
                  type="submit"
                  disabled={isButtonNotActive}
                  className={`w-[350px] p-3 rounded-[4px] flex ${
                    isLoading ? "bg-primary-light" : "bg-primary"
                  } font-medium text-[14px] text-white justify-center items-center`}
                >
                  Sign in
                </button>
              </form>

              {/* <div className="font-regular text-gray-600 text-[14px]">
                Not registered?{" "}
                <Link to="/auth/request" className="font-medium text-primary">
                  Request for an account
                </Link>
              </div> */}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
